import { Component, OnInit } from "@angular/core";
import { User } from "app/core/models/user";
import { ApplicationInfo } from "app/core/models/application-info";

import { AuthService } from "app/core/services/auth.service";
import { DimmerService } from "app/core/services/dimmer.service";
import { SystemService } from "app/core/services/system.service";

import { environment } from "../../../../environments/environment";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { CustomError } from "app/core/models/custom-error";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"]
})
export class RegisterComponent implements OnInit {
  newUserInfo: {
    name: string;
    email: string;
    password: string;
    c_password: string;
    agreed: boolean;
  } = {
      name: null,
      email: null,
      password: null,
      c_password: null,
      agreed: false
    };

  callback: string = environment.APP_ROOT; //environment

  actionError: CustomError;

  justRegistered: boolean = false;

  tokenValid: boolean = false;

  submitted: boolean = false;

  enteredFields = {
    email: true,
    password: true,
    passwordsMatch: true,
    agreed: true
  };

  passwordRequirements = {
    length: false,
    uppercase: false,
    lowercase: false,
    number: false
  };

  passwordRequirementsMet: boolean = false;

  shouldShowDisclaimer: boolean = false;
  appInfo: ApplicationInfo;


  inProgress: boolean = false;

  constructor(
    private authService: AuthService,
    private dimmerService: DimmerService,
    private systemService: SystemService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.submitted = false;

    //get appInfo
    this.systemService.appInfo.subscribe(appInfo => {
      this.appInfo = appInfo;
    });
  }

  checkPasswordRequirements() {
    //Check length
    if (this.newUserInfo.password.length >= 8) {
      this.passwordRequirements.length = true;
    } else {
      this.passwordRequirements.length = false;
    }

    //Check upper case
    const uppserCaseRegex = /^(?=.*[A-Z]).+$/;
    if (uppserCaseRegex.test(this.newUserInfo.password)) {
      this.passwordRequirements.uppercase = true;
    } else {
      this.passwordRequirements.uppercase = false;
    }

    //check lower case
    const lowerCaseRegex = /^(?=.*[a-z]).+$/;
    if (lowerCaseRegex.test(this.newUserInfo.password)) {
      this.passwordRequirements.lowercase = true;
    } else {
      this.passwordRequirements.lowercase = false;
    }

    //check number
    const numberRegex = /^(?=.*[0-9_\W]).+$/;
    if (numberRegex.test(this.newUserInfo.password)) {
      this.passwordRequirements.number = true;
    } else {
      this.passwordRequirements.number = false;
    }

    if (
      this.passwordRequirements.length &&
      this.passwordRequirements.lowercase &&
      this.passwordRequirements.uppercase &&
      this.passwordRequirements.number
    ) {
      this.passwordRequirementsMet = true;
    } else {
      this.passwordRequirementsMet = false;
    }

    //check passwords match
    if (this.newUserInfo.password == this.newUserInfo.c_password) {
      this.enteredFields.passwordsMatch = true;
    } else {
      this.enteredFields.passwordsMatch = false;
    }
  }

  checkPasswordsMatch() {
    if (this.newUserInfo.password == this.newUserInfo.c_password) {
      this.enteredFields.passwordsMatch = true;
    } else {
      this.enteredFields.passwordsMatch = false;
    }
  }

  async register() {


    this.submitted = true;



    // console.log(this.newUserInfo);

    //validate user input

    let hasErrors: boolean = false;

    if (this.newUserInfo.email == null) {
      this.enteredFields.email = false;
      hasErrors = true;
    }

    //check password requirements
    if (this.passwordRequirementsMet) {
      this.enteredFields.password = true;
    } else {
      this.enteredFields.password = false;
      hasErrors = true;
    }

    //check passwords match
    if (this.newUserInfo.password == this.newUserInfo.c_password) {
      this.enteredFields.passwordsMatch = true;
    } else {
      this.enteredFields.passwordsMatch = false;
      hasErrors = true;
    }

    //check if agreed
    if (!this.newUserInfo.agreed) {
      this.enteredFields.agreed = false;
      hasErrors = true;
    }


    if (!hasErrors) {
      //submit the form

      this.inProgress = true;

      try {
        const userData = await this.authService.createUser(
          this.newUserInfo,
          this.callback
        );
        this.justRegistered = true;
        this.inProgress = false;

      } catch (error) {

        this.inProgress = false;

        // console.log(error);
        this.actionError = error;

      }
    }
  }

  showDisclaimer() {
    this.dimmerService.dimWindow(true);
    this.shouldShowDisclaimer = true;
  }

  closeDisclaimer() {
    this.dimmerService.dimWindow(false);
    this.shouldShowDisclaimer = false;
  }

  disclaimerAgreed() { }
}
